import type { RefObject } from 'react'
import { useEffect } from 'react'

export const useBlurFocusWithinWhenClosed = (container: RefObject<HTMLElement | null>, opened: boolean) => {
  useEffect(() => {
    const focused = document.activeElement

    if (!opened && focused instanceof HTMLElement && container.current?.contains(focused)) focused.blur()
  }, [container, opened])
}
